/** Wraps Supporter-only content for FREE members: a dashed gold container with a rotated red
 * "EXAMPLE" stamp, dimmed + non-interactive inner, and a gold unlock nudge underneath.
 * Copy mirrors profile-activity-free.html. */
import type { ReactNode } from 'react';

interface ExampleBlockProps {
  children: ReactNode;
  hint: ReactNode;
}

export function ExampleBlock({ children, hint }: ExampleBlockProps) {
  return (
    <div className="exwrap">
      <div className="exstamp">EXAMPLE</div>
      <div className="inner" aria-hidden="true">{children}</div>
      <div className="exhint">{hint}</div>
    </div>
  );
}
